import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=3b39a3ae&scoped=true"
import script from "./columns.vue?vue&type=script&lang=js"
export * from "./columns.vue?vue&type=script&lang=js"
import style0 from "./columns.vue?vue&type=style&index=0&id=3b39a3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b39a3ae",
  null
  
)

export default component.exports